export const staircaseConfig = {
    gameSlug: 'reaction-sport',
    category: 'feu_vivacite',
    variable: 'duration_ms',
    startValue: 500,
    minValue: 180,
    maxValue: 1000,
    stepSizesByPhase: [50, 30, 20, 10],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    maxTrials: 24,
    direction: 'down-easier',
};
function buildVariant(level) {
    if (level <= 10) {
        return {
            level,
            mode: 'simple',
            preSignalMinMs: 1500,
            preSignalMaxMs: 3500,
            label: 'SRT visuel',
        };
    }
    if (level <= 20) {
        return {
            level,
            mode: 'simple',
            preSignalMinMs: 1000,
            preSignalMaxMs: 3000,
            label: 'SRT vif',
        };
    }
    if (level <= 30) {
        return {
            level,
            mode: 'choice2',
            preSignalMinMs: 1500,
            preSignalMaxMs: 3500,
            label: 'Choice RT 2 couleurs',
        };
    }
    if (level <= 40) {
        return {
            level,
            mode: 'choice2',
            preSignalMinMs: 1000,
            preSignalMaxMs: 3000,
            label: 'Choice RT vif',
        };
    }
    return {
        level,
        mode: 'choice2',
        preSignalMinMs: 800,
        preSignalMaxMs: 2500,
        label: 'Limite reflex',
    };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
/** Durees non-staircase. */
export const timing = {
    fixationMs: 400,
    /** Cap d'affichage du signal avant timeout no-tap. */
    signalCapMs: 1200,
    feedbackMs: 600,
    itiMs: 700,
};
export const paradigmMeta = {
    slug: 'reaction-sport',
    paradigm: 'Simple/Choice Reaction Time (Donders 1868 / Deary & Der 2005)',
    masterMage: 'Embra (feu-vivacite)',
    category: 'feu_vivacite',
    goal: 'Latence cerveau-muscle : sport, conduite, signature neuro-motrice.',
};
//# sourceMappingURL=params.js.map